import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Adsense } from '@ctrl/react-adsense';
import './AdComponents.css';

/**
 * Composant de bannière publicitaire Amazon responsive
 * Leaderboard: 728x90 (desktop/tablette) | 320x50 (mobile)
 */
export const AmazonBanner = ({ 
  link = "https://amazon.fr/votre-lien-affilie",
  title = "Découvrez notre sélection d'équipement apicole",
  subTitle = "Équipement de qualité pour apiculteurs urbains",
  image = "https://images.unsplash.com/photo-1558818498-28c1e002b655?w=728&h=90&fit=crop",
  backgroundColor = "#FFF9E6" // Crème léger
}) => {
  return (
    <div className="w-full flex justify-center">
      {/* Desktop & Tablette - 728x90 */}
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer sponsored"
        className="hidden sm:block group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all"
        style={{ width: '728px', height: '90px', backgroundColor }}
      >
        <div className="absolute inset-0 flex items-center justify-between px-6">
          {/* Image à gauche */}
          <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
            <img 
              src={image} 
              alt={title}
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Texte au centre */}
          <div className="flex-1 px-4">
            <p className="text-gray-900 font-semibold text-base leading-tight">
              {title}
            </p>
            <p className="text-sm text-gray-600 mt-1">
              {subTitle}
            </p>
          </div>
          
          {/* CTA à droite */}
          <div className="flex items-center space-x-2 bg-honey px-4 py-2 rounded-lg group-hover:bg-honey/90 transition-colors">
            <span className="text-white font-semibold text-sm whitespace-nowrap">Voir sur Amazon</span>
            <ExternalLink className="h-4 w-4 text-white" />
          </div>
        </div>
        
        {/* Badge "Sponsorisé" */}
        <div className="absolute top-1 right-1 bg-gray-100 px-2 py-0.5 rounded text-[10px] text-gray-600">
          Sponsorisé
        </div>
      </a>

      {/* Mobile - 320x50 */}
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer sponsored"
        className="sm:hidden group relative overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-all"
        style={{ width: '320px', height: '50px', backgroundColor }}
      >
        <div className="absolute inset-0 flex items-center justify-between px-3">
          {/* Image miniature */}
          <div className="w-10 h-10 rounded overflow-hidden flex-shrink-0">
            <img 
              src={image} 
              alt={title}
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Texte */}
          <div className="flex-1 px-2">
            <p className="text-gray-900 font-semibold text-xs leading-tight line-clamp-2">
              {title}
            </p>
          </div>
          
          {/* CTA mini */}
          <div className="bg-honey px-2 py-1 rounded group-hover:bg-honey/90 transition-colors">
            <ExternalLink className="h-3 w-3 text-white" />
          </div>
        </div>
        
        {/* Badge "Sponsorisé" mobile */}
        <div className="absolute top-0.5 right-0.5 bg-gray-100 px-1.5 py-0.5 rounded text-[8px] text-gray-600">
          Pub
        </div>
      </a>
    </div>
  );
};

/**
 * Composant Google AdSense responsive
 * Billboard: 970x250 (desktop/tablette) | 414x125 (mobile)
 */
export const AdSenseBillboard = ({ adSlot, adClient }) => {
  // Si pas de slot AdSense fourni, afficher un placeholder
  if (!adSlot || !adClient) {
    return (
        <div className="w-full flex justify-center">
          <div className="hidden md:flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg text-gray-400 text-sm">
            <Adsense
                className='BillboardAdSlot'
                adTest='on' //Dev Only
            />
          </div>
        </div>
    )
    // return (
    //   <div className="w-full flex justify-center">
    //     {/* Desktop/Tablette - 970x250 */}
    //     <div className="hidden md:flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg text-gray-400 text-sm"
    //       style={{ width: '970px', height: '250px' }}>
    //       <div className="text-center">
    //         <p className="font-semibold mb-1">Google AdSense Billboard</p>
    //         <p className="text-xs">970 x 250 px</p>
    //       </div>
    //     </div>
        
    //     {/* Mobile - 414x125 */}
    //     <div className="md:hidden flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg text-gray-400 text-xs"
    //       style={{ width: '320px', height: '100px' }}>
    //       <div className="text-center">
    //         <p className="font-semibold mb-0.5">AdSense Billboard</p>
    //         <p className="text-[10px]">Mobile Format</p>
    //       </div>
    //     </div>
    //   </div>
    // );
  }

  return (
    <div className="w-full flex justify-center">
      <Adsense
        className='BillboardAdSlot'
        client={adClient}
        slot={adSlot}
      />
    </div>

    // <div className="w-full flex justify-center">
    //   {/* Desktop/Tablette */}
    //   <div className="hidden md:block">
    //     <ins
    //       className="adsbygoogle"
    //       style={{ display: 'inline-block', width: '970px', height: '250px' }}
    //       data-ad-client={adClient}
    //       data-ad-slot={adSlot}
    //       data-full-width-responsive="true"
    //     />
    //   </div>
      
    //   {/* Mobile */}
    //   <div className="md:hidden">
    //     <ins
    //       className="adsbygoogle"
    //       style={{ display: 'inline-block', width: '320px', height: '100px' }}
    //       data-ad-client={adClient}
    //       data-ad-slot={adSlot}
    //       data-ad-format="auto"
    //       data-full-width-responsive="true"
    //     />
    //   </div>
    //   <script>
    //     (adsbygoogle = window.adsbygoogle || []).push({});
    //   </script>
    // </div>
  );
};

/**
 * Composant Google AdSense Skyscraper
 * Fixe: 160x600 sur tous les devices
 */
export const AdSenseSkyscraper = ({ adSlot, adClient }) => {
  // Si pas de slot AdSense fourni, afficher un placeholder
  if (!adSlot || !adClient) {
    return (
        <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg text-gray-400 text-sm">
          <Adsense
              className='SkycrapperAdSlot'
              adTest='on' //Dev Only
          />
        </div>
      // <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg text-gray-400 text-sm"
      //   style={{ width: '300px', height: '600px' }}>
      //   <div className="text-center rotate-0">
      //     <p className="font-semibold mb-1 text-xs">AdSense</p>
      //     <p className="text-xs">Skyscraper</p>
      //     <p className="text-[10px] mt-2">300 x 600</p>
      //   </div>
      // </div>
    );
  }

  return (
    <Adsense
      className='SkycrapperAdSlot'
      client={adClient}
      slot={adSlot}
    />
    // <div>
    //   <ins
    //     className="adsbygoogle"
    //     style={{ display: 'inline-block', width: '300px', height: '600px' }}
    //     data-ad-client={adClient}
    //     data-ad-slot={adSlot}
    //   />
    //   <script>
    //     (adsbygoogle = window.adsbygoogle || []).push({});
    //   </script>
    // </div>
  );
};
